module.exports = "https://static.wmbcdn.com/uniweb/images/7fd39103ce61f3a047a253a5bc6a53d3.svg";